import { isNil } from 'ramda';
import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { MediaData } from '~admin/model/media-data';
import { MediaPickerInnerSwitch } from '~admin/view/components/ui/form/fields/media/media-picker-inner-switch.component';
import { MediaType } from '~client/model/media-type';
import { Box } from '~common/components/box.component';
import { Span } from '~common/components/span.component';
import { Color } from '~common/model/basics';
import { ImageIcon } from '~web/view/components/ui/icon/image.icon';
import { ScrollBar } from '~web/view/theme/utils';

interface Props {
  mediaType: MediaType;
  mediaList: MediaData[];
  onMediaSelected?: (media: MediaData) => void;
}

export const MediaPickerSearchInner: React.FunctionComponent<Props> = ({
  mediaType,
  mediaList,
  onMediaSelected,
}) => {
  const { t } = useTranslation();

  return (
    <Container>
      {((): ReactNode => {
        if (isNil(mediaList)) {
          return (
            <Content>
              <ImageIcon color={Color.Gray} width={64} height={64} />
            </Content>
          );
        }

        if (mediaList.length === 0) {
          return (
            <Content>
              <NotFoundLabel>
                {t('createEvent.eventDetails.media.overlay.search.notFound')}
              </NotFoundLabel>
            </Content>
          );
        }

        return (
          <MediaPickerInnerSwitch
            mediaType={mediaType}
            mediaList={mediaList}
            onMediaSelected={onMediaSelected}
          />
        );
      })()}
    </Container>
  );
};

const Container = styled(Box)`
  height: 420px;
  margin-top: 16px;
  ${ScrollBar};
`;

const Content = styled(Box)`
  width: 100%;
  align-items: center;
  justify-content: center;
`;

const NotFoundLabel = styled(Span)`
  font-weight: bold;
  font-size: 18px;
  line-height: 26px;
  color: ${(props): string => props.theme.colors.gray.v3};
  text-transform: uppercase;
`;



// WEBPACK FOOTER //
// ./view/components/ui/form/fields/media/media-overlay/media-picker-search-inner.component.tsx